"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.deleteDistributionsSuccess = exports.deleteDistributionsFailure = exports.deleteDistributionsRequest = exports.deleteDistributionsToggle = exports.setFilterOptions = exports.setOrderByOptions = exports.unselectItems = exports.selectItems = exports.setOffset = exports.setLimit = exports.setSearchString = exports.fetchDistributionListFailed = exports.fetchDistributionListSuccess = exports.fetchDistributionListRequest = void 0;
const ActionTypes = require("../../actionTypes/distribution/list");
const fetchDistributionListRequest = (project) => ({
    type: ActionTypes.FETCH_DISTRIBUTION_LIST_REQUEST,
    payload: project
});
exports.fetchDistributionListRequest = fetchDistributionListRequest;
const fetchDistributionListSuccess = (list) => ({
    type: ActionTypes.FETCH_DISTRIBUTION_LIST_SUCCESS,
    payload: {
        list
    }
});
exports.fetchDistributionListSuccess = fetchDistributionListSuccess;
const fetchDistributionListFailed = (error) => ({
    type: ActionTypes.FETCH_DISTRIBUTION_LIST_FAILED,
    payload: error
});
exports.fetchDistributionListFailed = fetchDistributionListFailed;
const setSearchString = (searchString) => ({
    type: ActionTypes.SET_SEARCH_STRING,
    payload: {
        searchString
    }
});
exports.setSearchString = setSearchString;
const setLimit = (limit) => ({
    type: ActionTypes.SET_LIMIT,
    payload: {
        limit
    }
});
exports.setLimit = setLimit;
const setOffset = (offset) => ({
    type: ActionTypes.SET_OFFSET,
    payload: {
        offset
    }
});
exports.setOffset = setOffset;
const selectItems = (selected) => ({
    type: ActionTypes.SELECT_ITEMS,
    payload: {
        selected
    }
});
exports.selectItems = selectItems;
const unselectItems = (unselected) => ({
    type: ActionTypes.UNSELECT_ITEMS,
    payload: {
        unselected
    }
});
exports.unselectItems = unselectItems;
const setOrderByOptions = (orderBy, order) => ({
    type: ActionTypes.SET_ORDER_BY_OPTIONS,
    payload: {
        orderBy,
        order
    }
});
exports.setOrderByOptions = setOrderByOptions;
const setFilterOptions = (filter, value) => ({
    type: ActionTypes.SET_FILTER_OPTIONS,
    payload: {
        filter,
        value
    }
});
exports.setFilterOptions = setFilterOptions;
const deleteDistributionsToggle = (open) => ({
    type: ActionTypes.DELETE_DISTRIBUTIONS_TOGGLE,
    payload: open
});
exports.deleteDistributionsToggle = deleteDistributionsToggle;
const deleteDistributionsRequest = (ids) => ({
    type: ActionTypes.DELETE_DISTRIBUTIONS_REQUEST,
    payload: {
        ids
    }
});
exports.deleteDistributionsRequest = deleteDistributionsRequest;
const deleteDistributionsFailure = (error) => ({
    type: ActionTypes.DELETE_DISTRIBUTIONS_FAILURE,
    payload: error
});
exports.deleteDistributionsFailure = deleteDistributionsFailure;
const deleteDistributionsSuccess = () => ({
    type: ActionTypes.DELETE_DISTRIBUTIONS_SUCCESS
});
exports.deleteDistributionsSuccess = deleteDistributionsSuccess;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=list.js.map